module.exports = __webpack_public_path__ + "static/media/1.6384f803.jpg";